export enum VideoType {
  PRODUCT_LONG = 'plv',
  PRODUCT_SHORT = 'psv',
  LINK_CONTENT = 'lcv',
  TEXT_CONTENT = 'tcv',
}

export const VIDEO_TYPE_LABELS = {
  [VideoType.PRODUCT_LONG]: '상품 롱폼',
  [VideoType.PRODUCT_SHORT]: '상품 숏폼',
  [VideoType.LINK_CONTENT]: '링크 컨텐츠',
  [VideoType.TEXT_CONTENT]: '텍스트 컨텐츠',
} as const

export const VIDEO_TYPE_DESCRIPTIONS = {
  [VideoType.PRODUCT_LONG]:
    '쿠팡, 알리 어필리에이트 상품으로 영상을 만들어보세요!',
  [VideoType.PRODUCT_SHORT]:
    '쿠팡, 알리 어필리에이트 상품으로 영상을 만들어보세요!',
  [VideoType.LINK_CONTENT]:
    '뉴스나 블로그 링크를 입력해서 컨텐츠 영상을 만들어보세요!',
  [VideoType.TEXT_CONTENT]:
    '영상으로 만들고 싶은 내용을 입력해서 컨텐츠 영상을 만들어보세요!',
} as const

export const VIDEO_TYPE_API_MAP = {
  [VideoType.PRODUCT_SHORT]: 'product',
  [VideoType.LINK_CONTENT]: 'contents',
} as const

// 유틸리티 함수들
export const getVideoTypeLabel = (type: VideoType): string => {
  return VIDEO_TYPE_LABELS[type] || ''
}

export const getVideoTypeDescription = (type: VideoType): string => {
  return VIDEO_TYPE_DESCRIPTIONS[type] || ''
}

export const getApiTypeByVideoType = (type: VideoType): string => {
  if (type === VideoType.PRODUCT_SHORT) return VIDEO_TYPE_API_MAP[type]
  if (type === VideoType.LINK_CONTENT) return VIDEO_TYPE_API_MAP[type]
  return VideoType.PRODUCT_SHORT
}

export const getVideoTypeFromParam = (param: string | null): VideoType => {
  switch (param) {
    case 'plv':
      return VideoType.PRODUCT_LONG
    case 'psv':
      return VideoType.PRODUCT_SHORT
    case 'lcv':
      return VideoType.LINK_CONTENT
    case 'tcv':
      return VideoType.TEXT_CONTENT
    default:
      return VideoType.PRODUCT_LONG
  }
}

// 비디오 타입별 가이드 정보
export interface GuideItem {
  type: 'link' | 'text'
  text: string
  href?: string
}

export const VIDEO_TYPE_GUIDES: Record<VideoType, GuideItem[]> = {
  [VideoType.PRODUCT_LONG]: [
    {
      type: 'link',
      href: 'https://blog.fastseller.shop/youtubeuploadguide/',
      text: '라이트플랜 영상 업로드 방법 가이드',
    },
    {
      type: 'text',
      text: '영상 다운로드는 생성 완료된 시점으로부터 30일간 가능합니다.',
    },
    {
      type: 'text',
      text: '프로, 프리미엄 플랜의 경우, 유튜브 권한 설정이 완료된 상태여야 유튜브 자동 업로드가 가능합니다.',
    },
    {
      type: 'text',
      text: "플랜별 영상 생성 개수는 사용자가 '생성 요청한 영상'의 개수를 기준으로 카운팅 합니다.",
    },
    { type: 'text', text: '영상 생성은 요청 후 3일 내에 완료됩니다.' },
    {
      type: 'text',
      text: '프로,프리미엄 플랜은 1일 최대 3개까지 오전 10시, 오후 2시, 오후 6시에 업로드 예약 됩니다',
    },
    {
      type: 'text',
      text: '생성과 업로드 일정 등은 서비스 현황에 따라 별도의 공지 없이 변동될 수 있습니다.',
    },
  ],
  [VideoType.PRODUCT_SHORT]: [
    {
      type: 'link',
      href: 'https://blog.fastseller.shop/youtubeuploadguide/',
      text: '숏폼 업로드 방법 가이드',
    },
    {
      type: 'text',
      text: '숏폼 파일 다운로드는 생성 완료된 시점으로부터 30일간 가능합니다.',
    },
    { type: 'text', text: '영상 생성은 요청 후 1일 내에 완료됩니다.' },
    {
      type: 'text',
      text: '생성과 업로드 일정 등은 서비스 현황에 따라 별도의 공지 없이 변동될 수 있습니다.',
    },
  ],
  [VideoType.LINK_CONTENT]: [
    {
      type: 'link',
      href: 'https://blog.fastseller.shop/youtubeshortsupload/',
      text: '컨텐츠 영상 업로드 방법 가이드',
    },
    {
      type: 'text',
      text: '컨텐츠 영상 파일 다운로드는 생성 완료된 시점으로부터 30일간 가능합니다.',
    },
    { type: 'text', text: '영상 생성은 요청 후 3일 내에 완료됩니다.' },
    {
      type: 'text',
      text: '생성 일정 등은 서비스 현황에 따라 별도의 공지 없이 변동될 수 있습니다.',
    },
  ],
  [VideoType.TEXT_CONTENT]: [
    {
      type: 'link',
      href: 'https://blog.fastseller.shop/youtubeshortsupload/',
      text: '컨텐츠 영상 업로드 방법 가이드',
    },
    {
      type: 'text',
      text: '컨텐츠 영상 파일 다운로드는 생성 완료된 시점으로부터 30일간 가능합니다.',
    },
    { type: 'text', text: '영상 생성은 요청 후 3일 내에 완료됩니다.' },
    {
      type: 'text',
      text: '생성 일정 등은 서비스 현황에 따라 별도의 공지 없이 변동될 수 있습니다.',
    },
  ],
}

export const getVideoTypeGuides = (type: VideoType): GuideItem[] => {
  return VIDEO_TYPE_GUIDES[type] || []
}

export enum CreateVideoType {
  PRODUCT_LONG = 'long',
  PRODUCT_SHORT = 'short',
}

export enum MaxSelectCnt {
  PRODUCT_LONG = 3,
  PRODUCT_SHORT = 1,
}
